<template>
<div class="l-container-content bg-white">
    <div class="row">
        <div class="col">
            <div class="text-title">
                <h3>Add Users</h3>
            </div>
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div v-show="successcreateStatus">
                <small class="text-success">{{successMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-4">
                    <label>First Name</label>
                    <input type="text" v-model="fname" placeholder="Enter Full name">
                </div>
                <div class="col-4">
                    <label>Middle Name</label>
                    <input type="text" v-model="mname" placeholder="Enter Full name">
                </div>
                <div class="col-4">
                    <label>Last Name</label>
                    <input type="text" v-model="lname" placeholder="Enter Full name">
                </div>
                <div class="col-6">
                    <label>Phone number</label>
                    <input type="tel" v-model="phone" placeholder="Enter phone number">
                </div>
                <div class="col-6">
                    <label>Email</label>
                    <input type="email" v-model="email" placeholder="Enter Email">
                </div>
                <div class="col-6">
                    <label>Role</label>
                    <select v-model="userRoles">
                        <option value>Select Roles</option>
                        <option value="2">Client Administrator</option>
                        <option value="3">Customer Support</option>
                        <option value="4">Affiliate Marketer</option>
                        <option value="5">Affiliate Support</option>
                    </select>
                </div>
                <div class="col">
                    <button class="button primary" id="createUser" @click="createUser()">Create User</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import store from "../store";
import loader from "@/components/loader";
import $ from "jquery";
export default {
    data: function () {
        return {
            phone: "",
            email: "",
            fname: "",
            mname: "",
            lname: "",
            userRoles: "",
            errorcreateStatus: false,
            successcreateStatus: false,
            errorsMessage: "",
            successMessage: ""
        };
    },
    mounted() {
        let vm = this;
        // if (vm.$cookies.get("role_id") != 4) {
        //   vm.$router.push({ name: "dashboard" });
        // }
    },
    components: {
        loader
    },
    methods: {
        createUser() {
            $("#createUser").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            let vm = this;
            vm.errorcreateStatus = false;
            vm.successcreateStatus = false;
            vm.successMessage = "";
            vm.errorsMessage = "";
            $.post({
                url: store.state.rootUrl + 'portal/v1/add/system/user',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    token:vm.$cookies.get("accessToken"),
                    first_name: vm.fname,
                    last_name: vm.lname,
                    middle_name: vm.mname,
                    email_address: vm.email,
                    mobile_number: vm.phone,
                    role_id: vm.userRoles
                }),
                success: function (response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#createUser").text("Create User");
                    if(response.data.code == 200){
                        vm.errorcreateStatus = false;
                        vm.successcreateStatus = true;
                        vm.successMessage = response.data.message;
                    }
                    else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                    // swal("Success!", "Access Granted!", "success");

                },
                error: function (jQxhr, status, error) {
                  $("#createUser").text("Create User");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
          vm.successcreateStatus = false;
          vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        }
    }
};
</script>
